import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@demoiselle/security';
import { NotFoundComponent } from './shared/components/not-found.component';

// Import Containers
import {
  FullLayout,
  SimpleLayout
} from './shared/layout/containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: '',
    component: FullLayout,
    data: {
      title: 'Home'
    },
    children: [

      {
        path: 'reqdegustacao',
        loadChildren: './reqdegustacao/reqdegustacao.module#ReqDegustacaoModule',
        data: {
          title: 'Requisitar Degustação',
          showInSidebar: true,
          icon: 'icon-bubble'
        }
      },

      {
        path: 'listadegustacao',
        loadChildren: './listadegustacao/listadegustacao.module#ListaDegustacaoModule',
        data: {
          title: 'Gerenciar Degustações',
          showInSidebar: true,
          icon: 'icon-list',
          roles: [
            'ADMINISTRADOR',
            'USUARIO_MINISTERIO_PLANEJAMENTO',
            'USUARIO_SERPRO_INFRAESTRUTURA',
            'USUARIO_SERPRO_NEGOCIO'
          ]
        }
      }

    ]
  },
  {
    path: '',
    component: SimpleLayout,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: 'login',
        loadChildren: './auth/login/login.module#LoginModule',
      },
      {
        path: 'amnesia',
        loadChildren: './auth/amnesia/amnesia.module#AmnesiaModule',
      },
      {
        path: 'register',
        loadChildren: './auth/register/register.module#RegisterModule',
      }
    ]
  }
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/app-routing.module.ts